import dayjs from "dayjs";
import urlParser from "js-video-url-parser";
import stripHtml from "string-strip-html";

export function formatDateOrRange(beginStr, endStr) {
  if (beginStr && endStr) {
    const beginYear = dayjs(beginStr).format("YYYY");
    const endYear = dayjs(endStr).format("YYYY");
    let bd;
    if (beginYear === endYear) {
      const beginMonth = dayjs(beginStr).format("MM");
      const endMonth = dayjs(endStr).format("MM");
      if (beginMonth === endMonth) {
        bd = formatDateDayOnly(beginStr);
      } else {
        bd = formatDateDayMonthOnly(beginStr);
      }
    } else {
      bd = formatDate(beginStr);
    }
    const ed = formatDate(endStr);
    return bd + " → " + ed;
  } else if (beginStr) {
    return formatDate(beginStr);
  } else {
    return "";
  }
}

export function formatDateOrRangeNumeric(beginStr, endStr) {
  if (beginStr && endStr) {
    const bd = formatDateNumeric(beginStr);
    const ed = formatDateNumeric(endStr);
    return bd + " → " + ed;
  } else if (beginStr) {
    const bd = formatDateNumeric(beginStr);
    return bd;
  } else {
    return "";
  }
}

export function formatDate(dateStr) {
  return dayjs(dateStr).format("DD MMM YYYY");
}

export function formatDateDayMonthOnly(dateStr) {
  return dayjs(dateStr).format("DD MMM");
}

export function formatDateDayOnly(dateStr) {
  return dayjs(dateStr).format("DD");
}

export function formatDateNumeric(dateStr) {
  return dayjs(dateStr).format("YYYY.MM.DD");
}

export function capitalize(s) {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function validateVideoUrl(url) {
  return urlParser.parse(url) ? true : false;
}

export function getVideoUrlProvider(url) {
  const results = urlParser.parse(url);
  return results.provider;
}

export function getVideoUrlId(url) {
  const results = urlParser.parse(url);
  return results.id;
}

export function generateMetaTags(title, description, image) {
  const siteName = "EER";
  const url = window.location.href;
  let descStripped = null;
  if (description && typeof description === "object") {
    for (let i = 0; i < description.length; i++) {
      const block = description[i];
      if (block._key === "text" && block.text) {
        descStripped = stripHtml(block.text);
        break;
      }
    }
  } else {
    descStripped = description ? stripHtml(description) : null;
  }

  return [
    { vmid: "description", name: "description", content: descStripped },

    // Facebook
    { vmid: "og:site_name", property: "og:site_name", content: siteName },
    { vmid: "og:title", property: "og:title", content: title },
    { vmid: "og:type", property: "og:type", content: "website" },
    { vmid: "og:url", property: "og:url", content: url },
    { vmid: "og:image", property: "og:image", content: image },
    {
      vmid: "og:description",
      property: "og:description",
      content: descStripped,
    },

    // Twitter card
    { vmid: "twitter:card", name: "twitter:card", content: "summary" },
    { vmid: "twitter:site", name: "twitter:site", content: url },
    { vmid: "twitter:title", name: "twitter:title", content: title },
    {
      vmid: "twitter:description",
      name: "twitter:description",
      content: descStripped,
    },
    { vmid: "twitter:image:src", name: "twitter:image:src", content: image },

    // Google / Schema.org markup:
    { vmid: "name", itemprop: "name", content: title },
    { vmid: "g-description", itemprop: "description", content: descStripped },
    { vmid: "g-image", itemprop: "image", content: image },
  ];
}
